<template>
  <div class="m-1 p-3 customer-card border">
    <!-- details -->
    <div class="customer-card-details">
      <p class="p-0 m-0 font-weight-bold">{{name+" ("+dealerno+")"}}</p>
      <p class="p-0 m-0 mb-3">{{email}}</p>
    </div>
    <!-- notify dropdown -->
    <div class="customer-card-notify">
      <p class="p-0 m-0">notify on order (optional):</p>
      <b-form-select v-model="employeeToNotify" :options="employeesDropdown"></b-form-select>
    </div>
    <!-- options dropdown -->
    <div class="customer-card-options">
      <!-- <b-dropdown size="sm" variant="outline" no-caret>
        <template slot="button-content">
          <span>
            <i class="material-icons">more_horiz</i>
          </span>
        </template>
      </b-dropdown>-->
    </div>
    <!-- show orders button -->
    <div class="customer-card-show-orders">
      <b-button @click="showOrders = !showOrders">Show Orders</b-button>
    </div>
    <!-- orders table -->
    <div class="customer-card-orders">
      <b-collapse
        v-model="showOrders"
        :id="`parts-collapse-${dealerno}`"
        class="customer-card-parts"
      >
        <b-table :items="orders"></b-table>
      </b-collapse>
    </div>
    <!-- order count -->
    <div class="customer-card-order-count">
      <p>{{`${orders.length} orders`}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dealerno: Number
  },
  data() {
    return {
      showOrders: false,
      orders: []
    };
  },
  mounted() {
    // add cleaned up orders to table
    this.$store.getters["customer"](this.dealerno).orders.forEach(
      async orderno => {
        let completeOrder = await this.$orderService.getOrder(orderno);
        let date = new Date(completeOrder.date);
        this.$data.orders.push({
          orderNumber: completeOrder.order_number || "",
          date: date.toLocaleDateString(),
          numberOfParts: (completeOrder.parts || []).length,
          pickup: completeOrder.pickup ? "willcall" : "shipped"
        });
      }
    );
  },
  computed: {
    name() {
      return this.$store.getters["customer"](this.dealerno).name;
    },
    email() {
      return this.$store.getters["customer"](this.dealerno).email;
    },
    dealerNumber() {
      return this.$store.getters["customer"](this.dealerno).dealer_number;
    },
    employeeToNotify: {
      get() {
        let employeeID = this.$store.getters["customer"](this.dealerno)
          .employees_to_notify_on_order[0];
        if (!employeeID) return null;
        let employee = this.$store.state.employees.find(
          emp => emp._id === employeeID
        );
        return employee;
      },
      set(val) {
        this.$store.dispatch("addEmployeeToCustomerNotifyOnOrder", {
          employeeID: val._id,
          dealerNumber: this.dealerno
        });
      }
    },
    employeesDropdown() {
      let options = this.$store.state.employees.map(e => ({
        value: e,
        text: e.name
      }));
      options.unshift({ value: null, text: "Select an Employee" });
      return options;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";
.customer-card {
  width: 100%;
  max-width: 45em;
  display: grid;
  grid-template-rows: 4em 4em auto;
  grid-template-columns: 1fr 1fr 1fr;
  &-details {
    grid-area: 1/1/3/2;
  }

  &-notify {
    grid-area: 2/1/3/2;
    p {
      font-style: italic;
    }
  }

  &-options {
    grid-area: 1/3/2/4;
    justify-self: flex-end;
  }

  &-show-orders {
    grid-area: 2/3/3/4;
    justify-self: flex-end;
    align-self: flex-end;
  }

  &-order-count {
    grid-area: 1/2/2/3;
    color: green;
    align-self: center;
    justify-self: center;
  }

  &-orders {
    grid-area: 3/1/4/4;
  }
}
</style>


